import { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

const TrueInkCollectionProfileModal = ({
  open,
  onClose,
  templates,
  onSave,
}) => {
  const [selectedTemplate, setSelectedTemplate] = useState("");

  const handleSave = () => {
    if (selectedTemplate) {
      onSave(selectedTemplate);
      setSelectedTemplate("");
      onClose();
    }
  };

  const handleCancel = () => {
    setSelectedTemplate("");
    onClose();
  };

  return (
    <Modal open={open} onClose={handleCancel}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: "8px",
          boxShadow: 24,
          p: 3,
          width: {
            xs: "95%",
            md: 420
          },

          maxHeight: {
            xs: "95%",
            md: "75vh"
          },
          overflowY: "scroll",
          "&::-webkit-scrollbar": {
            width: "8px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(255, 255, 255, 0.3)",
            borderRadius: "10px",
            border: "2px solid transparent", // adds padding effect
            backgroundClip: "content-box",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.5)",
          },
        }}
      >
        <Typography variant="h8" gutterBottom>
          Please select a template to apply collection to tags
        </Typography>

        <RadioGroup
          value={selectedTemplate}
          onChange={(e) => setSelectedTemplate(e.target.value)}
        >
          {templates.map((tpl) => (
            <FormControlLabel
              key={tpl.id}
              value={tpl.id}
              control={<Radio />}
              label={tpl.name}
            />
          ))}
        </RadioGroup>

        <Box
          sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}
        >
          <Button
            onClick={handleCancel}
            variant="contained"

            sx={{
              textTransform: "none",
              background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
              color: "#fff",
              boxShadow: "none",
              "&:hover": {
                background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                opacity: 0.95,
                boxShadow: "none"
              },
              "&.Mui-disabled": {
                background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                opacity: 0.5,
                color: "#fff"
              }
            }}

          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            disabled={!selectedTemplate}
            sx={{
              textTransform: "none",
              color: "white",
              backgroundColor: "rgb(87,27,46)",
              "&:hover": {
                backgroundColor: "rgb(70, 20, 35)",
              },
              "&.Mui-disabled": {
                backgroundColor: "rgba(87,27,46,0.4)",
                color: "#fff",
              },
            }}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default TrueInkCollectionProfileModal;
